<template>
  <div>
    <b-loading :active.sync="isLoading" :is-full-page="true"></b-loading>

    <div>
      <div class="title">Step 1: pick a game</div>

      <b-autocomplete
          v-model="gameSelect"
          :data="games"
          :expanded="false"
          :keep-first="true"
          :loading="isLoading"
          :open-on-focus="true"
          clearable
          field="gameName"
          placeholder="e.g. Game name, map name, pack name..."
          size="is-large"
          @select="option => gameSelected(option)">

        <template slot-scope="props">
          <div class="media">
            <div class="media-left">
              <img :src="props.option.imageUrl" width="32">
            </div>
            <div class="media-content">
              <span><b>{{ props.option.gameName }}</b></span>
              <span style="margin-left: 3px">
                <b-tooltip :label="'This game is ' + props.option.gameStyle" position="is-right">
                  <b-icon :icon="isThereAnIconForGameStyle(props.option.gameStyle)" size="is-small"
                          type="is-dark"></b-icon>
                </b-tooltip>
              </span>
              <span v-if="props.option.accessType === 'public'" style="margin-left: 3px">
                <b-tooltip label="This game is public" position="is-right">
                  <b-icon icon="earth" size="is-small" type="is-dark"></b-icon>
                </b-tooltip>
              </span>
              <br>
              <small>{{ props.option.wizardInformation.chosenPack.packName }} -
                {{ props.option.wizardInformation.map.mapName }}
                ({{ props.option.wizardInformation.map.markers.length }} points)</small>
            </div>
          </div>
        </template>
      </b-autocomplete>


    </div>

    <div v-if="step2">
      <div class="title">Step 2: select packs</div>
      <b-field v-for="(option, index) in packs">
        <b-checkbox
            :key="index"
            v-model="checkboxPacks"
            :native-value="option.packId"
            @input="packSelected">
          {{ option.name }}
        </b-checkbox>
      </b-field>
    </div>
    <div v-if="step3">
      <div class="title">Step 3: choose options</div>

      <b-field>
        <b-button class="btn-margin" icon-left="check" type="is-success" @click="goCreate">Create
          {{ checkboxPacks.length }} games
        </b-button>
      </b-field>
    </div>
  </div>
</template>

<script>
import displayHelper from '../../helpers/display-helper'
import packService from '@/services/packService'
import gamesService from '@/services/gamesService'
import gameHelper from '@/helpers/game-helper'
import rawActivityService from '@/services/rawActivityService'
import gameStylesHelper from '@/enums/gameStyles'

export default {
  name: 'games-with-packs-en-masse',
  created() {
    this.loadGamesList()
  },
  data() {
    return {
      isLoading: false,
      packs: [],
      games: [],
      rawActivities: [],
      step2: false,
      step3: false,
      checkboxPacks: [],
      gameSelect: '',
      gameId: '',
    }
  },
  methods: {
    isThereAnIconForGameStyle: gameStylesHelper.isThereAnIconForGameStyle,

    loadPacksList() {
      this.isLoading = true
      const parent = this
      return packService.getPacks()
          .then((packs) => {
            this.packs = packs
            console.log(packs[0])
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    loadGamesList() {
      this.isLoading = true
      const parent = this
      return gamesService.getGames()
          .then((games) => {
            this.games = gameHelper.formatGames(games)
            console.log(games[0])
          })
          .catch((error) => {
            displayHelper.displayError(parent, 'Oops, there was an error while loading the games: ' + error.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    loadRawActivitiesList() {
      this.isLoading = true
      const parent = this
      return rawActivityService.getRawActivities()
          .then((rawActivities) => {
            this.rawActivities = rawActivities
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    gameSelected(option) {
      if (!option) {
        this.step2 = false
        return
      }

      this.gameId = option.idGame
      const theGame = _.find(this.games, ['idGame', this.gameId])

      this.loadPacksList()
          .then(() => {
            this.packs = _.filter(this.packs, pack => {
              return (pack.rawActivityIds && pack.rawActivityIds.length >= theGame.wizardInformation.map.markers.length) &&
                  pack.packId !== theGame.wizardInformation.chosenPack.packId
            })

            this.step2 = true
          })
    },
    packSelected() {
      this.step3 = true
    },
    goCreate() {
      const parent = this
      this.isLoading = true

      gamesService.createGamesWith1GameNPacks(this.gameId, this.checkboxPacks)
          .then(() => {
            displayHelper.displaySuccess(parent, 'The games have been created with success')
            this.$router.push({name: 'Games'})
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error while creating the games: ' + err.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    }
  },
}
</script>

<style scoped>
.title {
  margin-top: 20px;
}
</style>
